export default __webpack_public_path__ + "389e6ec3ac3e42e64fe9c2fd0958dae7.png";